import { CreateSourceBrowserbasePhase } from "@/pages/sources/components/create/sources/browserbase/types";

export enum CreateSourceBrowserbaseActionType {
  SET_SOURCE_NAME = "SET_SOURCE_NAME",
  SET_URL = "SET_URL",
  SET_PROMPT = "SET_PROMPT",
  SET_MANAGEMENT_MODE = "SET_MANAGEMENT_MODE",
  SET_API_KEY = "SET_API_KEY",
  SET_PROJECT_ID = "SET_PROJECT_ID",
  SET_MAX_URLS_TO_SCRAPE = "SET_MAX_URLS_TO_SCRAPE",
  SET_PHASE = "SET_PHASE",
  SET_ERROR = "SET_ERROR",
  SET_SHOULD_SHOW_ERRORS = "SET_SHOULD_SHOW_ERRORS",
}

export interface SetSourceNameAction {
  type: CreateSourceBrowserbaseActionType.SET_SOURCE_NAME;
  payload: string;
}

export interface SetUrlAction {
  type: CreateSourceBrowserbaseActionType.SET_URL;
  payload: string;
}

export interface SetPromptAction {
  type: CreateSourceBrowserbaseActionType.SET_PROMPT;
  payload: string;
}

export interface SetManagementModeAction {
  type: CreateSourceBrowserbaseActionType.SET_MANAGEMENT_MODE;
  payload: boolean;
}

export interface SetApiKeyAction {
  type: CreateSourceBrowserbaseActionType.SET_API_KEY;
  payload: string;
}

export interface SetProjectIdAction {
  type: CreateSourceBrowserbaseActionType.SET_PROJECT_ID;
  payload: string;
}

export interface SetMaxUrlsToScrapeAction {
  type: CreateSourceBrowserbaseActionType.SET_MAX_URLS_TO_SCRAPE;
  payload: number;
}

export interface SetPhaseAction {
  type: CreateSourceBrowserbaseActionType.SET_PHASE;
  payload: CreateSourceBrowserbasePhase;
}

export interface SetErrorAction {
  type: CreateSourceBrowserbaseActionType.SET_ERROR;
  payload: string | null;
}

export interface SetShouldShowErrorsAction {
  type: CreateSourceBrowserbaseActionType.SET_SHOULD_SHOW_ERRORS;
  payload: boolean;
}

export type CreateSourceBrowserbaseAction =
  | SetSourceNameAction
  | SetUrlAction
  | SetPromptAction
  | SetManagementModeAction
  | SetApiKeyAction
  | SetProjectIdAction
  | SetMaxUrlsToScrapeAction
  | SetPhaseAction
  | SetErrorAction
  | SetShouldShowErrorsAction;
